import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import {useAdminBucket} from "../../../components/utils";
import ExtractForm from "../../../components/data_products/extracts/ExtractForm";
import {
  useGetDataVendorExtractAggregationOptionsQuery,
  useGetDataVendorExtractQuery,
  useUpdateDataVendorExtractMutation
} from '../../../api/dataVendorExtractApiSlice';
import {useGetDataVendorAudiencesQuery} from "../../../api/dataVendorAudienceApiSlice";
import {useControlledTabs} from "../../../components/Tabs";


export default function EditDataVendorExtract(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey, extractId } = useParams();
  const bucket = useAdminBucket(dataVendorKey)
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [tabProps, setActiveTab] = useControlledTabs("extract", props)
  const { data: extract, isSuccess } = useGetDataVendorExtractQuery([dataVendorKey, extractId])
  const { data: aggregationOptions = [] } = useGetDataVendorExtractAggregationOptionsQuery(dataVendorKey)
  const { data: audiences = [] } = useGetDataVendorAudiencesQuery(dataVendorKey)

  const goToExtract = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}/extracts/${extractId}`,
    state: {activeTab: tabProps.active}
  })

  const [updateExtract] = useUpdateDataVendorExtractMutation()

  const submitProps = {
    handleSubmit: (data) => {
      updateExtract({...data, key: extractId, dataVendorId: dataVendorKey}).unwrap()
        .then(goToExtract)
        .catch(error => {})
    },
    errors: {}
  }

  if ( !isSuccess ) return (<></>)
  return (
    <>
      <Title
        main={t("menu.extracts")}
        sub={extract.name}
        group={false}
        onBack={goToExtract}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToExtract} />
      </Title>
      <ExtractForm
        bucket={bucket}
        extract={extract}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        aggregationOptions={aggregationOptions}
        audiences={audiences}
        tabProps={tabProps}
      />
    </>
  )
}

